import { useEffect } from 'react';
import { faqItems } from '@/mocks/data';
import SEOMeta from '@/components/base/SEOMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import HotPicks from './components/HotPicks';
import CategoryShowcase from './components/CategoryShowcase';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.documentElement.lang = 'zh-CN';
  }, []);

  const faqSchema = {
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOMeta
        title="嫩草影院 - 高清影视在线观看平台 | 免费在线电影电视剧动漫"
        description="嫩草影院是您最佳的在线影视观看平台，提供海量高清电影、电视剧、动漫、综艺等内容，支持免费流畅播放，无需注册即可享受优质观影体验，随时随地畅享精彩影视内容。"
        keywords="嫩草影院,嫩草影院高清在线,嫩草影院免费观看,嫩草影院电影,嫩草影院电视剧,在线影院免费,高清影视平台,免费电影,在线电影,免费电视剧"
        canonicalUrl="https://www.nencaoyingyuan.com"
      />

      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '嫩草影院 - 首页',
          url: 'https://www.nencaoyingyuan.com',
          description: '嫩草影院首页 - 高清影视在线观看平台',
        }}
      />
      <SchemaOrg type="FAQPage" data={faqSchema} />

      <div className="min-h-screen bg-background-950">
        <Navbar />

        <main>
          <article>
            <HeroBanner />
          </article>

          <HotPicks />

          <CategoryShowcase />

          <LatestUpdates />

          <CTASection />

          <FAQSection />
        </main>

        <Footer />
      </div>
    </>
  );
}